// Modal de criar/editar memória do Dwight (escopo + chave + valor).
import { useState } from 'react';
import axios from 'axios';
import { Modal, Form, Input, Select, App as AntApp } from 'antd';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import type { MemoriaItem } from './types';

interface Props {
  item: MemoriaItem | null;
  onClose: () => void;
  onSalvo: () => void;
}

export default function ModalMemoria({ item, onClose, onSalvo }: Props) {
  const { message } = AntApp.useApp();
  const [escopo, setEscopo] = useState<'usuario' | 'cliente' | 'time'>(item?.escopo || 'time');
  const [chave, setChave] = useState(item?.chave || '');
  const [valor, setValor] = useState(item?.valor || '');
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!chave.trim() || !valor.trim()) { message.warning('Preencha chave e valor.'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      if (item) {
        await axios.put(`${API_URL}/agentes/memoria/${item.id}`, { valor },
          { headers: { Authorization: token } });
      } else {
        await axios.post(`${API_URL}/agentes/memoria`, { escopo, chave, valor },
          { headers: { Authorization: token } });
      }
      message.success('Salvo.');
      onSalvo();
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onClose} onOk={salvar} confirmLoading={salvando} destroyOnClose
      title={item ? 'Editar memória' : 'Nova memória'} okText="Salvar" cancelText="Cancelar">
      <Form layout="vertical" size="small">
        <Form.Item label="Escopo">
          <Select value={escopo} onChange={setEscopo} disabled={!!item}
            options={[
              { label: 'Usuário (você)', value: 'usuario' },
              { label: 'Time / empresa (todos)', value: 'time' },
              { label: 'Cliente específico', value: 'cliente' },
            ]} />
        </Form.Item>
        <Form.Item label="Chave">
          <Input value={chave} onChange={e => setChave(e.target.value)} disabled={!!item}
            placeholder="ex.: preferencia_resposta, cliente:MIDT:contato_padrao"
            style={{ fontFamily: 'monospace' }} />
        </Form.Item>
        <Form.Item label="Valor">
          <Input.TextArea value={valor} onChange={e => setValor(e.target.value)} rows={3}
            placeholder="ex.: respostas curtas e diretas; sempre cobrar 30% adiantado..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
